import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faStar, faBook, faCopy, faFolder, faCodeBranch, faCaretDown, faCheck, faAt, faUsers, faSignOutAlt, faCog, faUpload, faAngleDown, faBan, faCaretUp, faAngleRight, faExclamationCircle, faArrowCircleUp, faMinusCircle, faArrowCircleDown, faInfoCircle, faChevronLeft, faEye, faPlus, faPrint, faUnlink, faExternalLinkAlt, faRecycle, faLayerGroup, faReply } from '@fortawesome/free-solid-svg-icons';
import {faBell, faUser, faFile, faBuilding, faEnvelope, faClone, faChartBar, faCheckCircle, faFilePdf, faFileExcel, faThumbsUp, faTimesCircle} from '@fortawesome/free-regular-svg-icons';
import {faGithub} from '@fortawesome/free-brands-svg-icons';
import Icon, { CloseOutlined, FilterOutlined, LoadingOutlined, SearchOutlined, CheckCircleOutlined, FileDoneOutlined, SendOutlined, SwapRightOutlined, ShareAltOutlined, SlackOutlined, WarningOutlined, FieldTimeOutlined, RiseOutlined, DownOutlined, UpOutlined, FilterFilled, PushpinOutlined, SaveOutlined, LineChartOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import ComplianceSVG from './svgs/ComplianceSVG';
import SelectColumnSVG from './svgs/SelectColumn';
import ResetFilterSVG from './svgs/ResetFilter';
import AdditionalSettingSVG from './svgs/AdditionalSettings';
import DeleteSVG from './svgs/Delete';
import EditSVG from './svgs/Edit';
import DownloadSVG from './svgs/DownloadSVG';
import SettingSVG from './svgs/SettingSVG';
import RefreshSVG from './svgs/RefreshSVG';
import FalsePositiveSVG from './svgs/FalsePositiveSVG';
import ConfirmSVG from './svgs/ConfirmSVG';
import IntegrationSVG from './svgs/IntegrationSVG';
import FailedSVG from './svgs/FailedSVG';
import AcceptRiskSVG from './svgs/AcceptRiskSVG';
import AcceptRiskSelectedSVG from './svgs/AcceptRiskSelectedSVG';
import AcceptRiskIconSVG from './svgs/AccptRisk';
import ConfirmIconSVG from './svgs/Confirm';
import CalendarSVG from './svgs/CalendarSVG';
import RunbookFilterIconSVG from './svgs/RunbookFilterIconSVG';
import RunbookCreateTicketSVG from './svgs/RunbookCreateTicketSVG';
import RunbookUpdateSeveritySVG from './svgs/RunbookUpdateSeveritySVG';
import RunbookSelectTriggerSVG from './svgs/RunbookSelectTriggerSVG';
import SupportSVG from './svgs/SupportSVG';
import globeSVG from './svgs/globe';
import ContainerIconSVG from './svgs/ContainerIconSVG';
import RunbookSlack from './svgs/RunbookSlackSVG';
import RunbookMsTeam from './svgs/RunbookMsTeamSVG';
import FindingsUserMentioned from './svgs/FindingUserMentioned';
import RightArrowSVG from './svgs/RightArrowSVG';
import PublishSVG from './svgs/PublishSVG';
import ScheduleSVG from './svgs/ScheduleSVG';
import DashboardSVG from './svgs/dashboard';
import DashSVG from './svgs/DashSVG';
import SortIconSVG from './svgs/SortIconSVG';
import SpeedometerSVG from './svgs/SpeedometerSVG';
import EditPencilSVG from './svgs/EditPencilSVG';
import CircleCheckedSVG from './svgs/CircleCheckedSVG';
import LinkSVG from './svgs/LinkSVG';
import MenuIconSVG from './svgs/MenuIconSVG';
import TicketSVG from './svgs/TicketSVG';
import MsTeamsSVG from './svgs/MsTeamsSVG';
import ExploitedSVGV2 from './svgs/ExploitedSVGV2';
import BiDirectionalSVG from './svgs/BiDirectionalSVG';
import RunbookPlaySVG from './svgs/RunbookPlaySVG';

export function ExternalLinkIcon({className, ...props}){
    return <FontAwesomeIcon icon={faExternalLinkAlt} className={classnames(className)} {...props} />;
}

export function CalendarIcon(props){
    return <Icon component={CalendarSVG} {...props} />
}

export function UserIcon({className, ...props}){
    return <FontAwesomeIcon icon={faUser} className={classnames(className)} {...props} />;
}

export function HelpIcon({...props}){
    return <FontAwesomeIcon icon={faInfoCircle} {...props} />;
}

export {
    HelpIcon as HelpSolidIcon
}

export function MenuIcon(props){
    return <Icon component={MenuIconSVG} {...props} />;
} 

export function PlayIcon({className, ...props}){
    return <CheckCircleOutlined className={classnames(className)} {...props} />
}

export function FilterIcon({className, ...props}){
    return <FilterOutlined className={classnames(className)} {...props} />;
    // return <FontAwesomeIcon icon={faFilter} className={classnames(className)} {...props} />;
}

export const FilterIconFilled = FilterFilled;

export function NotificationIcon({className, ...props}){
    return <FontAwesomeIcon icon={faBell} className={classnames(className)} {...props} />;
}

export function SuppressIcon({...props}){
    return <Icon component={AcceptRiskSVG} {...props} />
}

export function UnSuppressIcon({...props}){
    return <Icon component={AcceptRiskSelectedSVG} {...props} style={{color: props.color || '#5EC368'}}/>
}

export function AcceptRiskIcon({...props}){
    return <Icon component={AcceptRiskIconSVG} {...props} />
}

export function ConfirmIcon({...props}){
    return <Icon component={ConfirmIconSVG} {...props} />
}


export function FailedIcon({...props}){
    return <Icon component={FailedSVG} {...props} />
}

export function IntegrationIcon({...props}){
    return <Icon component={IntegrationSVG} {...props} />
}

export function ConfirmRiskIcon({...props}){
    return <Icon component={ConfirmSVG} {...props} />
}

export function FalsePositiveIcon({...props}){
    return <Icon component={FalsePositiveSVG} {...props} />
}

export function RefreshIcon({...props}){
    return <Icon component={RefreshSVG} {...props} />
}

export function TicketingIcon({...props}){
    return <Icon component={TicketSVG} {...props}  />
}

export function CloseIcon({className, ...props}){
    return <CloseOutlined className={classnames('clickable', className)} {...props} />;
}

export function BookIcon(props){
    return <FontAwesomeIcon icon={faBook} {...props} />;
}

export function StarIcon(props){
    return <FontAwesomeIcon icon={faStar} {...props} />;
}

export function CopyIcon(props){
    return <FontAwesomeIcon icon={faCopy} {...props} />;
}

export function BranchIcon(props){
    return <FontAwesomeIcon icon={faCodeBranch} {...props} />;
}

export function DownloadIcon(props){
    return <Icon component={DownloadSVG} {...props} />
}

export function CaretDownIcon(props){
    return <FontAwesomeIcon icon={faCaretDown} {...props} />;
}

export function CaretUpIcon(props){
    return <FontAwesomeIcon icon={faCaretUp} {...props}  />;
}

export function FileIcon(props){
    return <FontAwesomeIcon icon={faFile} {...props} />;
}

export function FolderIcon(props){
    return <FontAwesomeIcon icon={faFolder} {...props} />;
}

export function DeleteIcon(props){
    return <Icon component={DeleteSVG} {...props} className={classnames(props.className, 'rc-delete-icon')} />
}

export function CheckIcon(props){
    return <FontAwesomeIcon icon={faCheck} {...props} />;
}

/** @param {import('@ant-design/icons/lib/components/AntdIcon').AntdIconProps & { 'aria-label'?: string, 'aria-hidden'?: string }} props */
export function LoadingIcon(props = {}){
    const { 'aria-label': ariaLabel = 'Loading', ...rest } = props;
    return <LoadingOutlined aria-label={ariaLabel} {...rest} />;
}

export function BuildingIcon(props){
    return <FontAwesomeIcon icon={faBuilding} {...props} />;
}

export function EmailIcon(props){
    return <FontAwesomeIcon icon={faEnvelope} {...props} />;
}

export function AtIcon(props){
    return <FontAwesomeIcon icon={faAt} {...props} />;
}

export function SettingsIcon(props){
    return <FontAwesomeIcon icon={faCog} {...props} />;
}


export function SelectColumnIcon(props){
    return <Icon component={SelectColumnSVG} {...props}  />;
}

export function ResetFilterIcon(props){
    return <Icon component={ResetFilterSVG} {...props} />
}

export function AdditionalSettingIcon(props){
    return <Icon component={AdditionalSettingSVG} {...props} />
}

export function UsersIcon(props){
    return <FontAwesomeIcon icon={faUsers} {...props} />;
}

export function LogoutIcon(props){
    return <FontAwesomeIcon icon={faSignOutAlt} {...props} />;
}

export function CloneIcon(props){
    return <FontAwesomeIcon icon={faClone} {...props} />;
}

export function EditIcon(props){
    return <Icon component={EditSVG} {...props} />
}

export function RecycleIcon(props){
    return <FontAwesomeIcon className="clickable" icon={faRecycle} {...props}/>;
}

export function UploadIcon(props){
    return <FontAwesomeIcon icon={faUpload} {...props} />;
}

export function BarChartIcon(props){
    return <FontAwesomeIcon icon={faChartBar} {...props} />;
}

export function SearchIcon(props){
    return <SearchOutlined {...props} />;
}

export const AngleDownIcon = DownOutlined;

export const AngleUpIcon = UpOutlined;

export function CircleCheckIcon(props){
    return <FontAwesomeIcon icon={faCheckCircle} {...props} />;
}

export function CircleCrossIcon(props){
    return <FontAwesomeIcon icon={faTimesCircle} {...props} />;
}

export function PrintIcon(props){
    return <FontAwesomeIcon icon={faPrint} {...props} />;
}

export function CircleBanIcon(props){
    return <FontAwesomeIcon icon={faBan} {...props} />;
}

export const SeverityIcons = {
    Critical:({className, ...props}) => <FontAwesomeIcon className={classnames('critical', className)} icon={faExclamationCircle} {...props} />,
    High:({className, ...props}) => <FontAwesomeIcon className={classnames('high', className)} icon={faArrowCircleUp} {...props} />,
    Medium:({className, ...props}) => <FontAwesomeIcon className={classnames('medium', className)} icon={faMinusCircle} {...props} />,
    Low:({className, ...props}) => <FontAwesomeIcon className={classnames('low', className)} icon={faArrowCircleDown} {...props} />,
    Info:({className, ...props}) => <FontAwesomeIcon className={classnames('info', className)} icon={faInfoCircle} {...props} />,
}

export function PDFIcon(props) {
    return <FontAwesomeIcon icon={faFilePdf} {...props} />
}

export function CSVIcon(props) {
    return <FontAwesomeIcon icon={faFileExcel} {...props} />
}

export function ShareIcon(props) {
    return <ShareAltOutlined {...props} />
}

export function DownIcon(props) {
    return <FontAwesomeIcon icon={faAngleDown} {...props} />
}

export function RightIcon(props) {
    return <FontAwesomeIcon icon={faAngleRight} {...props} />
}

export function ThumbsUpIcon(props) {
    return <FontAwesomeIcon icon={faThumbsUp} {...props} />
}

export function CheveronLeftIcon(props) {
    return <FontAwesomeIcon icon={faChevronLeft} {...props} />
}

export function EyeIcon(props) {
    return <FontAwesomeIcon icon={faEye} {...props} />
}

export const SaveIcon = SaveOutlined;

export function SendIcon(props) {
    return <SendOutlined  {...props} />
}

export function GitHubIcon(props) {
    return <FontAwesomeIcon icon={faGithub} {...props} />
}

export function ComplianceIcon(props) {
    return <Icon component={ComplianceSVG} {...props}  />;
}

export function InfoIcon(props) {
    return <FontAwesomeIcon icon={faInfoCircle} {...props} />
}

export function PlusIcon(props) {
    return <FontAwesomeIcon icon={faPlus} {...props} />
}

export function ReportCompare(props) {
    return <FileDoneOutlined {...props} />
}

export function UnlinkIcon(props) {
    return <FontAwesomeIcon icon={faUnlink} {...props} />
}

export function LinkIcon(props) {
    return <Icon component={LinkSVG} {...props} />
}

export function SettingIcon(props){
    return <Icon component={SettingSVG} {...props} />
}

export function DashboardIcon(props){
    return <Icon component={DashboardSVG} {...props} />
}

export function SpeedometerIcon(props){
    return <Icon component={SpeedometerSVG} {...props} />
}

export function SwapRightIcon(props) {
    return <SwapRightOutlined {...props} />
}

export function SupportIcon(props){
    return <SupportSVG {...props} />
}

export function SortIcon(props){
    return <Icon component={SortIconSVG} {...props} />
}

export function EditPencilIcon(props) {
    return <Icon component={EditPencilSVG} {...props} />
}

export function CircleCheckGreenIcon(props) {
    return <Icon component={CircleCheckedSVG} {...props} />
}

export function MsTeamsIcon({...props}){
    return <Icon component={MsTeamsSVG} {...props}  />
}

export function RunbookPlayIcon({...props}){
    return <Icon component={RunbookPlaySVG} {...props}  />
}

export const SlackIcon = SlackOutlined;
export const RunbookFilterIcon = RunbookFilterIconSVG;
export const RunbookCreateTicketIcon = RunbookCreateTicketSVG;
export const RunbookUpdateSeverityIcon = RunbookUpdateSeveritySVG;
export const RunbookSelectTriggerIcon = RunbookSelectTriggerSVG;
export const RunbookSlackIcon = RunbookSlack;
export const RunbookMsTeamIcon = RunbookMsTeam;
export const FindingsUserMentionedIcon = FindingsUserMentioned;
export const RightArrowIcon = RightArrowSVG;
export const LineChartIcon = LineChartOutlined;

export function GlobeIcon(props) {
    return <Icon component={globeSVG} {...props} />
}

export function WarningIcon(props){
    return <WarningOutlined {...props} />
}

export function ContainerIcon(props){
    return <Icon component={ContainerIconSVG} {...props} />
}

export function LayerIcon(props){
    return <FontAwesomeIcon icon={faLayerGroup} {...props} />;
}

export function ReplyIcon(props) {
    return <FontAwesomeIcon icon={faReply} {...props} />;
}

export function PublishIcon(props){
    return <Icon component={PublishSVG} {...props} />
}
export function ScheduleIcon(props){
    return <Icon component={ScheduleSVG} {...props} />
}
export function DashIcon(props){
    return <Icon component={DashSVG} style={{marginBottom: 3}} {...props} />
}
export function HistoryIcon(props){
    return <FieldTimeOutlined {...props} />
}

export function TrendingIcon(props){
    return <RiseOutlined {...props} />
}

export function ExpolitedIconV2(props){
    return <Icon component={ExploitedSVGV2} {...props} />
}

export function BiDirectionalIcon(props){
    return <Icon component={BiDirectionalSVG} {...props} />
}

export function PinIcon(props){
    return <PushpinOutlined {...props} />
}

export function EmptyIcon() {
    return null;
}
